package uz.ferro.erp.feature.product.model

import kotlinx.serialization.Serializable

@Serializable
data class RegionProducts(
    val region: Region,
    val products: List<Product>
)
